import { api } from './index';

export const getPilotPermissionsByUidOrCallsign = async (params: { uid?: string; callsign?: string }): Promise<any> => {
  return api.get('/pilot-permissions/user', { params });
};

export const savePilotPermissions = async (uid: string, permissions: any[]): Promise<any> => {
  return api.post(`/pilot-permissions/user/${uid}`, { permissions });
};

export const getPilotPermissionsList = async (params: { page?: number; limit?: number; search?: string }): Promise<any> => {
  return api.get('/pilot-permissions/list', { params });
};

export const getPilotPermissionLogs = async (params: { target_pilot_id?: string; page?: number; pageSize?: number }): Promise<any> => {
  return api.get('/pilot-permissions/logs', { params });
};

export const getMyStudentsWithPermissions = async (): Promise<any> => {
  return api.get('/pilot-permissions/my-students');
}; 